//Required in order to create a provider for the injector when creating components dynamically
export abstract class PageComponentDataProvider{}
